import React from 'react'
import StarRating from '@components/common/StarRating'
import RatingBar from './RatingBar'
import Spacer from '@components/common/Spacer'
import { getProductRating } from '@utils'

const ProductRatings = ({data, className=''}) => {
  const {
    totalReviews,
    average,
  } = getProductRating(data)

  return (
    <React.Fragment>
      <section className={`w-full space-y-4 ${className}`}>
        <div className="flex flex-nowrap gap-x-2">
        <h1 className="font-normal">{isNaN(average) ? "0.0" : average.toFixed(1)}</h1>
          <div className="w-full space-y-2">
            <StarRating readOnly={true} initalRating={average} />
            <p>Based on {totalReviews} reviews</p>
          </div>
        </div>

        <Spacer height='1px' />

        <div className="w-full flex flex-wrap">
          {data?.ratings?.sort((a, b) => b.star - a.star)?.map((item, index) => {
            return (
              <RatingBar
                key={`rating-${index + 1}`}
                starLabel={item.star}
                reviewCount={item.total}
                percentage={( item.total / totalReviews) * 100}
              />
            );
          })}
        </div>
      </section>
    </React.Fragment>
  );
}

export default ProductRatings